import { host } from '../../utils/globals';
import { FLICKER_API_HOST, FLICKR_API_KEY, FLICKR_USER_ID, GALLERY_METHOD, DETAIL_METHOD, IMAGE_LARGE_H, THUMBNAIL_IMAGE } from "./Constants";

export const DISTRICT_LIST_API_URL = `${host}/api/district/list`;

export const DASHBOARD_LIST_API_URL = `${host}/api/dashboard-map/list`;

export const EVENTS_LIST_API_URL = `${host}/api/meeting/list`;

export const FAQ_CATEGORY_LIST_API_URL = `${host}/api/faq-category/list`;

export const FAQ_API_URL = `${host}/api/faq/list`;

export const HOMEPAGE_LATEST_NEWS_API_URL = `${host}/api/news-list/news-type?newsType=latest-news&limit=4`;

export const HOMEPAGE_MAP_INFOGRAPHY_API_URL = `${host}/api/home-page/map-infographic/list?limit=30`;

export const HOMEPAGE_DATASET_API_URL = `${host}/api/dataset/list?_format=json&limit=6&dataType=dataset`;

export const HOMEPAGE_BULLETIN_API_URL = `${host}/api/home-page/resource-material/list?_format=json&limit=1&category_alias=hrrp-bulletins`;

export const SLIDER_API_URL = `${host}/api/slider/list`;

export const MARQUEE_NEWS_API_URL = `${host}/api/marquee-news/list?limit=10`;

export const HOMEPAGE_PARTNER_STORIES_API_URL = `${host}/api/landing/partner-story/list`;

export const HOMEPAGE_HRRP_REFERENCE_API_URL = `${host}/api/home-page/resource-material/list?limit=10`;

export const HOMEPAGE_RECENT_MINUTES_API_URL = `${host}/api/home-page/recent-minutes/list?limit=10`;

export const TEAM_WITH_CATEGORY_LIST_API_URL = `${host}/api/team-by-category/list`;

export const TEAM_CATEGORY_LIST_API_URL = `${host}/api/team-category/list`;

export const MAP_LIST_API_URL = `${host}/api/maps-infographics/list?_format=json&category_group=map`;

export const MAP_CATEGORY_LIST_API_URL = `${host}/api/map-infographic-category/list?_format=json&recordType=map`;

export const RESOURCE_MATERIAL_CATEGORY_LIST_API_URL = `${host}/api/resource-material-category/list?`;

export const MEETING_CATEGORY_LIST_API_URL = `${host}/api/meeting-category/list`;

export const MEETING_LIST_API_URL = `${host}/api/meeting/list`;

export const RESOURCE_MATERIAL_LIST_API_URL = `${host}/api/resource-material/list`;

export const INFOGRAPHIC_LIST_API_URL = `${host}/api/maps-infographics/list?_format=json&category_group=infographics`;

export const INFOGRAPHICS_CATEGORY_LIST_API_URL = `${host}/api/map-infographic-category/list?_format=json&recordType=infographic`;

export const FLICKER_IMAGES_API_URL = `${FLICKER_API_HOST}?method=${GALLERY_METHOD}&api_key=${FLICKR_API_KEY}&user_id=${FLICKR_USER_ID}&primary_photo_extras=url_m&format=json&nojsoncallback=1`;

export const FLICKER_DETAIL_IMAGES_API_URL = `${FLICKER_API_HOST}?method=${DETAIL_METHOD}&api_key=${FLICKR_API_KEY}&user_id=${FLICKR_USER_ID}&extras=url_${IMAGE_LARGE_H},url_m,url_${THUMBNAIL_IMAGE}&format=json&nojsoncallback=1`;

export const PARTNERS_LIST_API_URL = `${host}/api/partners/list`;

export const PARTNERS_STORIES_LIST_API_URL = `${host}/api/paginates-partner-story/list`;

export const PARTNERS_STORY_DETAIL_API_URL = `${host}/api/partner-story/{id}/details`;

export const SETTINGS_API_URL = `${host}/api/settings`;

export const IMPORTANT_LINKS_API_URL = `${host}/api/important-links/list`;
